/* tslint:disable:no-use-before-declare */
import * as H from 'history';
import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Order from '../order';
import OrderList from '../orderList';
import OrderTrack from '../orderTrack';
import Review from '../review';
import ReviewList from '../reviewList';
import classNames from './appMain.classNames';
/* tslint:enable:no-use-before-declare */

const appMain = withRouter((x: { history: H.History }) => {
  return (
    <div className={classNames().full}>
      <div className={classNames().root}>
        <Switch>
          <Route exact path='/reviews' component={ReviewList}/>
          <Route path='/reviews/:token' component={Review}/>
          <Route path='/customer/orders' component={OrderList} exact/>
          <Route path='/customer/orders/:orderId' component={Order} exact/>
          <Route path='/customer/orders/:orderId/track' component={OrderTrack} exact/>
        </Switch>
      </div>
    </div>);
});

export default appMain;
